import styled from 'styled-components';

export const NavigationWrapper = styled.div`
  width: ${(props) => (props.isCollapsed ? '80px' : '270px')};
  overflow-x: hidden;
  transition: width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;

  .ant-menu-root {
    height: 100%;
    overflow-y: auto;
  }

  .ant-menu-item-divider {
    border-color: #2f3240;
  }
  .toggler-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: ${(props) =>
      props.isCollapsed ? 'center' : 'space-between'};
    padding: ${(props) =>
      props.isCollapsed ? '2.5px 0px 0px 30px' : '20px 1px 16px 18px'};
    .nav-toggle-btn {
      background-color: inherit;
      border: none;
    }

    .nav-logo {
      display: ${(props) => (props.isCollapsed ? 'none' : 'block')};
      width: 25px;
      height: 25px;
      object-fit: contain;
      user-select: none;
      transform: scale(1.8);
    }
  }
`;
